import { GlobalFooter } from "@/patterns/global-footer/src/index";

import { EnterprisePageProductNav } from "../../enterprise-landing-page/sections";

import ConstantSelector from "./sections/constant-selector";

export const EnterpriseContactSalesPageTemplate = () => {
    return (
        <div>
            <EnterprisePageProductNav />
            <div>
                <div>
                    {/* EnterpriseContactSalesPage content */}
                    <ConstantSelector />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
